import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { installSchedulerAuth } from './schedulerAuth';

// Every call to the Scheduler backend carries the shared key (see schedulerAuth.js).
installSchedulerAuth();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
